export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (err) {
    // Fallback for older browsers
    const textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand('copy');
      return true;
    } catch (fallbackErr) {
      return false;
    } finally {
      document.body.removeChild(textArea);
    }
  }
};

export const generateId = () => {
  return Math.random().toString(36).substr(2, 9);
};

export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

export const isDateDisabled = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

export const getAvailableTimeSlots = (serviceId, selectedDate) => {
  // This would normally check against booking database
  // For now, return all slots as available
  const serviceSlots = {
    'craniosacral-therapy': ['9:00 AM', '11:00 AM', '5:00 PM', '7:00 PM'],
    'meditation': ['7:00 AM', '10:00 AM', '6:00 PM', '8:00 PM'],
    'personal': ['10:00 AM', '2:00 PM', '4:00 PM']
  };
  
  return serviceSlots[serviceId] || [];
};

export const simulatePayment = (amount, customerDetails) => {
  return new Promise((resolve) => {
    // Simulate payment processing time
    setTimeout(() => {
      // Always succeed for demo purposes
      resolve({
        success: true,
        transactionId: `TXN${Date.now()}`,
        amount: amount,
        timestamp: new Date().toISOString()
      });
    }, 2000);
  });
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

export const getErrorMessage = (error) => {
  if (typeof error === 'string') return error;
  if (error.message) return error.message;
  return 'An unexpected error occurred';
};

export const formatPrice = (amount) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone) => {
  const phoneRegex = /^[+]?[\d\s\-()]{10,15}$/;
  return phoneRegex.test(phone.replace(/\s/g, ''));
};

export const validatePAN = (pan) => {
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  return panRegex.test(pan);
};